import { ISendEmail, IResponseEmail } from "../interfaces/sendEmail";

interface IResponseApi {
  message?: string;
  details?: string;
}

export async function SendEmail(emailObj: ISendEmail): Promise<IResponseEmail> {
  try {
    const baseUrl: string | undefined = process.env.REACT_APP_API_URL;

    if (!baseUrl) {
      return {
        success: false,
        message: "Nodemailer URL is not defined.",
      };
    }

    const response = await fetch(`${baseUrl!}/send-email`, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ ...emailObj }),
    });

    if (!response.ok) {
      return {
        success: false,
        message: "Erro ao enviar email.",
      };
    }

    const { message: resMsg, details: resDet }: IResponseApi =
      await response.json();

    if (resMsg?.includes("Failed") || resMsg?.includes("Error")) {
      return {
        success: false,
        message: resDet,
      };
    }

    return {
      success: true,
      message: resDet,
    };
  } catch (error: any) {
    const failedResponse: IResponseEmail = {
      success: false,
      message: "Erro de servidor.",
    };

    return failedResponse;
  }
}
